/**
 * The main content area is the app's scroll container. See Page.tsx
 */
export const MAIN_CONTENT_SCROLL_ID = 'mainContent';

export const MAIN_CONTENT_SCROLL_SELECTOR = `[data-scroll-restoration-id="${MAIN_CONTENT_SCROLL_ID}"]`;
